var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntersectingWaveLayers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 66,
    viewBox: "0 0 1000 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3504_3264)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0 66V-2.6226e-06C166.7 -2.6226e-06 166.7 43.56 333.3 43.56C499.9 43.56 500 15.18 666.7 15.18C833.4 15.18 833.3 47.52 1000 47.52V66H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0 66V-2.6226e-06C166.7 -2.6226e-06 166.7 43.56 333.3 43.56C499.9 43.56 500 19.8 666.7 19.8C833.4 19.8 833.3 55.44 1000 55.44V66H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 66V-2.6226e-06C166.7 -2.6226e-06 166.7 43.56 333.3 43.56C499.9 43.56 500 24.42 666.7 24.42C833.4 24.42 833.3 63.36 1000 63.36V66H0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3504_3264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 66,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 66)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntersectingWaveLayers);
export default __webpack_public_path__ + "static/media/intersecting-wave-layers.51a7ba83151265e71dc339673a5d6137.svg";
export { ForwardRef as ReactComponent };